import React from "react";
import PropTypes from "prop-types";
import Icon from "../../../common/Icon";
import connectToMedia from "../../Media/connectToMedia";
import S from "../../../styles/components";
import Tooltip from "../../../common/ToolTip";
import Smiley from "../../../assets/icons/Smiley.svg";
import SmileyMeh from "../../../assets/icons/SmileyMeh.svg";
import SmileySad from "../../../assets/icons/SmileySad.svg";
import { upperCase, isEqual } from "lodash";

const mapStateToProps = (state) => ({ duration: state.media.duration });

function getColorBySentimentValue(value) {
  if (value >= 0.1) {
    return "#4B9368";
  }
  if (value >= 0.07 && value < 0.1) {
    return "#5EB480";
  }
  if (value >= 0.03 && value < 0.07) {
    return "#7CC77F";
  }
  if (value >= 0.01 && value < 0.03) {
    return "#A6CB62";
  }
  if (value >= 0 && value < 0.01) {
    return "#D6D94B";
  }
  if (value >= -0.01 && value < 0) {
    return "#E1B239";
  }
  if (value >= -0.02 && value < -0.01) {
    return "#F19A32";
  }
  if (value >= -0.04 && value < -0.02) {
    return "#F0812C";
  }
  if (value >= -0.06 && value < -0.04) {
    return "#F0632A";
  }
  if (value >= -0.08 && value < -0.06) {
    return "#EA4627";
  }
  if (value <= -0.08) {
    return "#B3361E";
  }
  return "#E1B239";
}

function setSentimentTooltip(title, sentiment, sentimentValue, sentimentIcon) {
  return (
    <S.GridRow>
      <S.GridCell>
        <S.ControlsGroup>
          <img height="50" alt="Sentiment smiley" src={sentimentIcon} />
        </S.ControlsGroup>
        <S.TooltipContent>
          <div style={{ opacity: "50%", paddingTop: "7px" }}>{title}</div>
          <div>
            {sentiment}{" "}
            <span>{`(${Math.round(sentimentValue * 100) / 100})`}</span>
          </div>
        </S.TooltipContent>
      </S.GridCell>
    </S.GridRow>
  );
}
class RegionTrack extends React.Component {
  static propTypes = {
    height: PropTypes.number,
    regions: PropTypes.arrayOf(
      PropTypes.shape({
        start: PropTypes.number.isRequired,
        end: PropTypes.number.isRequired,
        color: PropTypes.string,
      })
    ).isRequired,
    duration: PropTypes.number,
    color: PropTypes.string,
    isSentimentAnalyzerOn: PropTypes.bool,
  };

  static defaultProps = {
    height: 8,
    color: "black",
  };

  shouldComponentUpdate(nextProps) {
    const list = ["label", "height", "regions", "duration", "color"];
    return !list.every((key) => this.props[key] === nextProps[key]);
  }

  getTooltipBySentimentValue(value) {
    const { title } = this.props;
    const tooltipTitle = `${upperCase(title)} SENTIMENT`;
    if (value > 0.05) {
      return setSentimentTooltip(tooltipTitle, "Positive", value, Smiley);
    }
    if (value < 0) {
      return setSentimentTooltip(tooltipTitle, "Negative", value, SmileySad);
    }
    return setSentimentTooltip(tooltipTitle, "Neutral", value, SmileyMeh);
  }

  render() {
    const {
      title,
      icon,
      height,
      regions,
      duration,
      color,
      isSentimentAnalyzerOn,
      transcriptLength,
      isChatTextMedia,
      turns,
      messagesDuration,
      isDetectorTrack = false,
    } = this.props;

    const mediaDuration = isChatTextMedia
      ? (messagesDuration > 1000 ? messagesDuration + 1000 : messagesDuration)
      : duration || transcriptLength;

    if (mediaDuration) {
      return (
        <>
          <S.Track>
            <S.TrackLabel title={title}>
              {/* <Icon type={icon} style={{ color }} />  */}
              {title}
            </S.TrackLabel>
          </S.Track>
          <S.Track>
            {/* <S.TrackLabel title={title} style={{ paddingTop: "15px" }}> */}
            {/* <Icon type={icon} style={{ color }} />  */}
            {/* {title} */}
            {/* </S.TrackLabel> */}
            <S.TrackContent>
              <svg
                width="100%"
                height={height}
                shapeRendering="crispEdges"
                viewBox="0 0 100 10"
                preserveAspectRatio="none"
                style={{ display: "block" }}
              >
                {regions.map((region, i) => {
                  let width =
                    ((region.end - region.start) / mediaDuration) * 100;

                  if (region.end === region.start) {
                    if (isDetectorTrack) {
                      width = (500 / mediaDuration) * 100;
                    } else if (isChatTextMedia) {
                      const sentimentIndex = turns?.findIndex((turn) =>
                        isEqual(turn, region)
                      );

                      const timeDiff = turns[sentimentIndex + 1]
                        ? turns[sentimentIndex + 1].start - region.start
                        : region.start;
                      width = (timeDiff / mediaDuration) * 100;
                    }
                  }
                  return (
                    <Tooltip
                      key={`${region.start}-${region.end}-${i}`}
                      placement="bottom"
                      trigger={["hover"]}
                      overlayStyle={
                        !isSentimentAnalyzerOn && { display: "none" }
                      }
                      overlay={
                        <span>
                          {this.getTooltipBySentimentValue(region.value)}
                        </span>
                      }
                    >
                      <rect
                        key={`${region.start}-${region.end}-${i}`}
                        x={(region.start / mediaDuration) * 100}
                        y="0"
                        width={width}
                        height="10"
                        fill={
                          isSentimentAnalyzerOn
                            ? getColorBySentimentValue(region.value)
                            : color
                        }
                      />
                    </Tooltip>
                  );
                })}
              </svg>
            </S.TrackContent>
          </S.Track>
        </>
      );
    }

    return null;
  }
}
export default connectToMedia(mapStateToProps)(RegionTrack);
